import React, { useEffect, useState } from "react";
import authApiService from "../../services/authServices";
import { ThreeDots } from 'react-loader-spinner';

const CourtsDem = ({ courtData, isLoading }) => {
  const [seasonData, setSeasonData] = useState([]);
  const selectedCity = JSON.parse(localStorage.getItem("selectedCity"));
  const cityId = selectedCity?.id;

  useEffect(() => {
    const fetchPaymentData = async () => {
      try {
        const response = await authApiService.get(`paymentFetch?cityId=${cityId}`);
        if (response.data.length > 0) {
          setSeasonData(response.data);
        }
      } catch (error) {
        console.error("Error fetching payment data:", error);
      }
    };

    fetchPaymentData();
  }, [cityId]);

  const renderCourtCard = (court, index, isEmpty = false) => (
    <div key={isEmpty ? `empty-${index}` : court.id} className="threecol-frame col-lg-4 mb-4 item-self-stretch">
      <div className="court shadow-sm grey-box p-5 h-100">
        <div className='body-content'>
          <h2 className="court_card_heading" style={{ color: '#5d5d5d', display: isEmpty ? 'none' : '-webkit-box' }}>{court.name}</h2>
          <p>Address: <span>{isEmpty ? '' : court.court_address}</span></p>
          <p>City: <span>{isEmpty ? '' : court.court_city}</span></p>
          <p>State: <span>{isEmpty ? '' : court.court_state}</span></p>
          <p>Number of Courts: <span>{isEmpty ? '' : court.numberOfCourts}</span></p>
          <p>Lighted: <span>{isEmpty ? '' : court.court_lighted}</span></p>
          <p>Hours: <span>{isEmpty ? '' : `${court.openCourtHour} ${court.openCourtMeridiem} - ${court.closeCourtHour} ${court.closeCourtMeridiem}`}</span></p>
        </div>
      </div>
    </div>
  );

  const visibleCourtData = courtData || [];
  // Show all courts - no limit
  const filledCards = visibleCourtData; // Show all courts
  
  // Only show empty placeholder cards if no courts exist and no payment data
  const shouldShowEmptyCards = seasonData.length === 0 && filledCards.length === 0;
  const emptyCardCount = shouldShowEmptyCards ? 6 : 0; // Show 6 empty cards as placeholder if no data

  if (isLoading) {
    return (
      <div className="page-container col-sm-9 mb-5">
        <div className="loader-container" style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '400px',
          width: '100%'
        }}>
          <ThreeDots
            height="80"
            width="80"
            radius="9"
            color="#4fa94d"
            ariaLabel="three-dots-loading"
            visible={true}
          />
        </div>
      </div>
    );
  }

  return (
    <div className="page-container courts-pageTop col-sm-9 mb-5">
      <div className="courts-page-heading">
        <h2>Local Courts</h2>
      </div>
      <div className="courts-page-content">
      <div className="row">
        {filledCards.map((court, index) => renderCourtCard(court, index))}
        {Array.from({ length: emptyCardCount }).map((_, index) =>
          renderCourtCard({}, index + filledCards.length, true)
        )}
      </div>
      </div>
    </div>
  );
};

export default CourtsDem;

